
import { mapGetters } from 'vuex';
import { defineComponent } from 'vue';
import { adService } from '../AdService';
import { countries, defaultCountry } from '@/shared/constants/mapCountries';
import Multiselect from 'vue-multiselect';
import GoogleAutocomplete from '@/shared/components/GoogleAutocomplete.vue';
import { GoogleMapLoaderService } from '@/shared/services/GoogleMapLoaderService';
import { isNumber } from '@/utils';
import { mapCountries } from '@/shared/constants/mapCountries';
import config from '@/shared/constants/config';

export default defineComponent({
  components: {
    Multiselect,
    GoogleAutocomplete,
  },
  props: {},
  computed: {
    ...mapGetters(['isMobile']),
  },
  data() {
    return {
      isEstateAgencyMode: config.IS_ESTATE_AGENCY_MODE,
      adTypes: [] as null | any[],
      estateTypes: [],
      estateSubTypes: [] as any[],
      defaultCountry: defaultCountry,
      country: null,
      countries: null,
      showList: false,
      place: null as null | any,
      queryParams: {
        type: null as null | any,
        estateFrontSubTypes: [] as any[],
        countryCode: null as null | string,
      },
      sortByTypes: [] as any[],
      locationFilterText: null as null,
    };
  },
  async created() {
    try {
      this.country = defaultCountry;
      this.countries = [defaultCountry, ...countries.filter((x) => x.key !== defaultCountry.key)];
      this.sortByTypes = adService.getSortByTypes(this.$t);
      this.adFilter = (await adService.getFilter({ adFilterId: this.$route.query.adFilterId })).data;

      if (!this.adTypes) this.adTypes = [];
      this.adTypes.push(...this.adFilter.adTypes);

      this.estateTypes = this.adFilter.estateTypes;

      for (let item of this.estateTypes) {
        this.estateSubTypes.push(...(item as any).estateSubTypes);
      }

      let queryParams = null;

      if (this.$store.state.adSearchParams) {
        queryParams = this.$store.state.adSearchParams as any;
      }

      await this.initQueryParams(queryParams);
    } catch (error) {
      console.error(error);
    } finally {
      this.isCreated = true;
    }
  },
  methods: {
    selectAdType(value: number) {
      if (this.queryParams.type === value) this.queryParams.type = null;
      else this.queryParams.type = value;
    },
    onCountryChanged() {
      this.place = null;
      this.locationFilterText = null;
    },
    onPlaceChanged(address: any, placeResult: any) {
      if (address && placeResult) {
        this.place = {
          address,
          placeResult,
        };
      } else {
        this.place = null;
      }
    },
    async submit() {
      let params = this.getSearchParams();
      await this.saveParamsToUrl(params);
    },
    getSearchParams() {
      const params = Object.assign({}, this.queryParams);

      params.countryCode = this.country.key;

      if (this.showList) {
        params.viewType = 'fullscreen';
      }

      if (params.estateFrontSubTypes && params.estateFrontSubTypes.length > 0) {
        params.estateFrontSubTypes = params.estateFrontSubTypes.map((x) => x.key);
      }

      if (this.place && this.place.placeResult && this.place.placeResult.place_id) {
        params.place_id = this.place.placeResult.place_id;
      } else {
        params.place_id = null;
        params.zoom = null;
        const country = mapCountries[params.countryCode];
        params.swlat = country.sw_lat;
        params.swlng = country.sw_lng;
        params.nelat = country.ne_lat;
        params.nelng = country.ne_lng;
      }

      return params;
    },
    async saveParamsToUrl(searchParams) {
      let result = await adService.getParamsToUrl(searchParams, this.place, this.adFilter);
      const { href } = this.$router.resolve(result.routerParams);
      let url = `${href}?${result.qsString}`;
      document.location.href = url;
    },
    async initQueryParams(params) {
      if (!params) params = {};

      if (params.estateFrontSubTypes && params.estateFrontSubTypes.length > 0) {
        for (let i = 0; i < params.estateFrontSubTypes.length; i++) {
          let type = this.estateSubTypes.find((x) => (x as any).key === +params.estateFrontSubTypes[i]);
          if (type) {
            params.estateFrontSubTypes[i] = type;
          }
        }
      }
      if (isNumber(params.type)) params.type = +params.type;
      else params.type = null;
      if (isNumber(params.page)) params.page = +params.page;
      else params.page = null;
      if (isNumber(params.pageSize)) params.pageSize = +params.pageSize;
      else params.pageSize = null;
      if (isNumber(params.priceFrom)) params.priceFrom = +params.priceFrom;
      else params.priceFrom = null;
      if (isNumber(params.priceTo)) params.priceTo = +params.priceTo;
      else params.priceTo = null;
      if (isNumber(params.status)) {
        const status = this.statuses.filter((x) => x.key === +params.status);
        if (status.length > 0) params.status = status[0];
      } else params.status = null;

      const sortByType = this.sortByTypes.filter((x) => x.value == params.sortBy);
      if (sortByType.length > 0) this.sortBy = sortByType[0];
      else params.sortBy = this.defaultSortBy;

      if (params.swlat || params.swlng || params.nelat || params.nelng) {
        if (isNumber(params.swlat) && isNumber(params.swlng) && isNumber(params.nelat) && isNumber(params.nelng)) {
          this.bounds = {
            swlat: +params.swlat,
            swlng: +params.swlng,
            nelat: +params.nelat,
            nelng: +params.nelng,
          };
        } else {
          params.swlat = null;
          params.swlng = null;
          params.nelat = null;
          params.nelng = null;
        }
      }

      if (params.zoom) {
        if (isNumber(params.zoom)) {
          this.zoom = params.zoom = +params.zoom;
        } else {
          params.zoom = null;
        }
      }

      if (params.countryCode) {
        this.country = this.countries.find((x) => x.key === params.countryCode);
        if (!this.country) params.countryCode = null;
      }

      if (params.place_id) {
        await GoogleMapLoaderService.load();
        let place = await adService.getPlace(params.place_id);
        if (place) {
          this.$refs.place.setPlace(place);
          this.locationFilterText = this.place.placeResult.formatted_address;
        }
      }

      this.queryParams = params;
    },
  },
});
